import React, { useEffect, useRef } from "react";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/Footer/Footer";
import "./email-verification.css";
import { Navigate, useNavigate } from "react-router-dom";
import { LoaderContext } from "../../context/LoaderContext";
import { useContext } from "react";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal/confirmation-modal";
import { AcknowledgementModal } from '../../components/Modals/AcknowledgementModal/acknowledgement-modal'
import checkIcon from "../../assets/images/greenCheck.png";

export function EmailVerificationSuccessPage() {
  const { showloader, hideloader } = useContext(LoaderContext);
  const router = useNavigate();

  const subTextA = "Would you like to enable Multi-Factor Authentication? You can chose to do this later.";
  const subTextB = "You now have full access to your account.";

  function RenderProperModal() {
    // Parse the query string using URLSearchParams
    let params = new URLSearchParams(window.location.search);
    // Access the parameters
    let registration_url_params = params.get("registered") ?? "";
    //show enable MFA if this is registraion
    if (registration_url_params.toLowerCase() === "true") {
      return (
        <ConfirmationModal
          id="email-verification-success-modal"
          icon={checkIcon}
          showDivider={true}
          header="Email Verified Successfully!"
          message={subTextA}
          isActive={true}
          animate={false}
          confirmText={"Setup MFA"}
          denyText={"Setup Later"}
          onConfirm={SetupMFA}
          onDeny={Dashboard}
          confirmClass="btn-green"
        />
      );
    } else {
      return (
        <AcknowledgementModal
          id="email-verification-success-modal"
          icon={checkIcon}
          showDivider={true}
          header="Email Verified Successfully!"
          message={subTextB}
          isActive={true}
          animate={false}
          onAcknowledge={Dashboard}
          buttonText={"Head To My Dashboard"}
        />
      );
    }
  }

  function SetupMFA() {
    router("/mfa-setup");
  }

  function Dashboard() {
    router("/dashboard");
  }

  return (
    <>
      <Navbar />
      <section className="register-page-bg">{RenderProperModal()}</section>
      <Footer />
    </>
  );
}
